import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getAxiosCancelTokenSource } from '../../app.utils';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import {
    addOrderToList,
    generateQuickLinkCategories,
    getUniqueQuickLinks,
    myToolsConstants,
} from '../../components/Tools/mytools.constant';

const toolsState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    resourceLinks: '',
    myQuickLinks: null,
    categoryMaster: null,
};

const toolsMutations = {
    [storeMutation.setResourceLinks]: (state, data) => {
        state.resourceLinks = data;
    },
    [storeMutation.setMyQuickLinks]: (state, data) => {
        state.myQuickLinks = addOrderToList(getUniqueQuickLinks(data));
    },
    [storeMutation.updateQuickLinks]: (state, data) => {
        state.myQuickLinks = data;
        if (state.categoryMaster && state.categoryMaster.length) {
            state.categoryMaster[0].links = [...state.myQuickLinks];
        }
    },
    [storeMutation.setCategoryMaster]: (state, data) => {
        state.categoryMaster = data ? generateQuickLinkCategories(data, state.myQuickLinks) : null;
    },
};

const toolsActions = {
    [storeAction.getResourceLinks]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}profiles/api/tools/get-resource-links`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setResourceLinks, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getMyQuickLinks]: wrapAction(storeAction.getMyQuickLinks, ({ state, commit }) => {
        commit(storeMutation.setMyQuickLinks, null);
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getMyQuickLinks,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        return axios({
            url: `${state.baseURL}profiles/api/quick-Links/get-person-quickLinks`,
            headers: getBasicHeaders(),
            method: 'GET',
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getMyQuickLinks, { root: true });
                commit(storeMutation.setMyQuickLinks, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveQuickLinks]: wrapAction(storeAction.saveQuickLinks, ({ state, commit, dispatch }, links) => {
        return axios({
            url: `${state.baseURL}profiles/api/quick-Links/save-person-quickLinks`,
            headers: getBasicHeaders(),
            data: links,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.updateQuickLinks, links);
                dispatch(storeAction.getCategoryLinks);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getCategoryLinks]: ({ state, commit }) => {
        commit(storeMutation.setCategoryMaster, null);
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getCategoryLinks,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        return axios({
            url: `${state.baseURL}profiles/api/quick-Links/get-available-person-quickLinks`,
            headers: getBasicHeaders(),
            method: 'GET',
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.setCategoryMaster, response.data);
                commit(storeMutation.removeCancelableRequest, storeAction.getCategoryLinks, { root: true });
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
};

const toolsGetters = {
    [storeGetters.resourceLinks]: state => state.resourceLinks,
    [storeGetters.shareYourIdeasLinks]: (state) => {
        const links = [];
        if (state.resourceLinks && state.resourceLinks.length) {
            state.resourceLinks.forEach((subElement) => {
                subElement.forEach((item) => {
                    if (item.resourceCenterCategoryName === myToolsConstants.SHARE_YOUR_IDEAS) {
                        links.push(item);
                    }
                });
            });
        }
        return links;
    },
    [storeGetters.myQuickLinks]: state => state.myQuickLinks,
    [storeGetters.categoryMaster]: state => state.categoryMaster,
};

export default {
    namespaced: true,
    state: {
        initialState: toolsState,
        ...toolsState,
    },
    mutations: { ...toolsMutations },
    actions: { ...toolsActions },
    getters: { ...toolsGetters },
};
